export default __webpack_public_path__ + "static/media/thumbnail4.62c187cb.png";